<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import {detailMember, memberDelete, memberList, batchFreeRegister} from "@/api/member/member.js";
import {listMemberLevel} from '@/api/member/member.js';
import {ElMessage} from "element-plus";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import {getRoute} from "@/hooks/getRoute.js";
import router from "@/router/index.js";
import { referrerTypeEnum, handleReferrerTypeKey2Label } from "@/enum/referrerTypeEnum.js"
const {route} = getRoute();

/*初次加载*/
onMounted(async () => {
  handleSearch()
  await getMemberLevelList()
})

/*搜索功能*/
// 推荐人类型枚举
const referrerType = ref(referrerTypeEnum)
// 表单数据
const formData = reactive({
  userId: null,
  phoneOrNickname: null,
  referrerType: null,
  referrerId: null
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value?.getPage() || 1,
      pageSize: YTTablePaginationRef.value?.getPageSize() || 20
    })
    loading.value = true;
    const res = await memberList(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.userId = null
  formData.phoneOrNickname = null
  formData.referrerType = null
  formData.referrerId = null
  handleSearch("btnSearch")
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '用户昵称', key: 'nickname', minWidth: '100px', nowrap: true },
  { title: '用户头像', key: 'avatar', maxWidth: '120px', nowrap: true },
  { title: '用户ID', key: 'userId', minWidth: '100px', nowrap: true },
  { title: '等级', key: 'memberLevel', minWidth: '100px', nowrap: true },
  { title: '联系电话', key: 'userProfile.contactPhone', minWidth: '100px', nowrap: true },
  { title: '个人姓名', key: 'userProfile.contactName', minWidth: '100px', nowrap: true },
  { title: '紧急联系人', key: 'userProfile.emergencyContactName', minWidth: '100px', nowrap: true },
  { title: '紧急联系人电话', key: 'userProfile.emergencyContactPhone', minWidth: '100px', nowrap: true },
  { title: '推荐人ID', key: 'referrerId', minWidth: '100px', nowrap: true },
  { title: '推荐人昵称', key: 'referrerNickname', minWidth: '100px', nowrap: true },
  { title: '注册手机号', key: 'phone', nowrap: true },
  { title: '时间', key: 'lastLogin', minWidth: '180px', nowrap: true },
  { title: '注册时间', key: 'crTime', minWidth: '180px', nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏功能*/
// 是否展示详情
const isShowDetail = ref(false)
// 展示的详情信息
const detailInfo = ref()
// 获取详情信息
const getMemberDetail = (info) => {
  isShowDetail.value = true
  detailInfo.value = info
  detailInfo.value.referrerType = handleReferrerTypeKey2Label(detailInfo.value.referrerType)
  detailInfo.value.referrerNickname = detailInfo.value.referrerNickname ? detailInfo.value.referrerNickname : '-'
}
// 处理详情返回列表
const handleToList = async () => {
  isShowDetail.value = false
  await nextTick(async () => {
    await handleSearch()
  })
  handleReset()
  initDetailInfo()
}
// 清空详情缓存
const initDetailInfo = () => {
  detailInfo.value = null
}
// 根据path获取的id搜索用户详情
const handleDetail = async (id) => {
  loading.value = true
  try {
    detailInfo.value = await detailMember(id)
    if (!detailInfo.value) {
      ElMessage.error("暂无此用户信息")
      await router.replace({
        path: route.path,
        query: {},
      });
      await handleSearch()
      initDetailInfo()
      return
    }
    isShowDetail.value = true
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*升级VIP*/
// 升级VIP
const memberLevelList = ref([])
const isShowUpgradeDialog = ref(false)
// 显示升级VIP弹窗
const handleUpgradeVIP = () => {
  isShowUpgradeDialog.value = true
}
// 获取会员等级列表
const getMemberLevelList = async () => {
  memberLevelList.value = await listMemberLevel()
}
// 确认升级VIP
const confirmUpgradeVIP = async () => {
  try {
    loading.value = true
    let param = {
      memberLevelId: memberLevelList.value.find(item => item.levelCode == 'L3').memberLevelId,
      // memberLevelId: detailInfo.value.memberLevel.memberLevelId,
      phoneList: [detailInfo.value.phone],
    }
    await batchFreeRegister(param)
    loading.value = false
    // 更新详情信息
    await handleSearch()
    getMemberDetail(tableData.value.find(item => item.userId == detailInfo.value.userId))
    isShowUpgradeDialog.value = false
    ElMessage.success("升级成功")
  } catch (e) {
    console.log(e)
    loading.value = false
    ElMessage.error("升级失败")
  }
}

/*删除操作对话框*/
const dialogConfirm = async (item) => {
  try {
    loading.value = true
    await memberDelete(item.memberId)
    loading.value = false
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <div class="container_box" v-if="!isShowDetail">
    <v-row justify="center">
      <v-col cols="10">
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loading"
          :items-per-page="$globalPageSize"
          :no-data-text="'没有更多数据了~'"
          hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>
          <template v-slot:item.avatar="{ item }">
            <div v-if="item.avatar" class="flex_left">
              <el-avatar shape="square" :size="80" fit="contain" :src="item.avatar" />
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="start">
                  <v-col cols="2">
                    <v-text-field
                        v-model="formData.userId"
                        placeholder="请输入用户ID"
                        label="用户ID"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                        v-model="formData.phoneOrNickname"
                        placeholder="请输入联系电话/用户昵称"
                        maxlength="11"
                        label="联系电话/用户昵称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                        v-model="formData.referrerType"
                        placeholder="选择推荐人类型"
                        variant="outlined"
                        label="推荐人类型"
                        clearable
                        :items="referrerType"
                        item-title="stateName"
                        item-value="stateId"
                    ></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                        v-model="formData.referrerId"
                        placeholder="请输入推荐人Id"
                        label="推荐人Id"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'member:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'member:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.memberLevel=" { item }">
            <div>{{item.memberLevel.levelName}}</div>
          </template>

          <template v-slot:item.referrerType="{ item }">
            <div>{{handleReferrerTypeKey2Label(item.referrerType)}}</div>
          </template>

          <template v-slot:item.referrerId="{ item }">
            <div>{{item.referrerId === "0" ? "-" : item.referrerId}}</div>
          </template>

          <template v-slot:item.referrerNickname="{ item }">
            <div>{{item.referrerNickname ? item.referrerNickname : "-"}}</div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="getMemberDetail(item)" v-show="$handleHasBtnPermission('all', 'member:view')"></v-icon>
              </el-tooltip>
              <el-popconfirm @confirm="dialogConfirm(item)" :title="`确定删除此用户吗？`">
                <template #reference>
                  <div>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right"
                        @click.stop>
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" v-show="$handleHasBtnPermission('all', 'member:delete')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <div v-else v-loading="loading">
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="用户ID"
            placeholder="用户ID"
            variant="underlined"
            v-model="detailInfo.userId"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="联系电话"
            placeholder="联系电话"
            variant="underlined"
            v-model="detailInfo.phone"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="微信ID"
            placeholder="微信ID"
            variant="underlined"
            v-model="detailInfo.openid"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <div class="flex_left">
          <v-text-field
              label="等级"
              placeholder="等级"
              variant="underlined"
              v-model="detailInfo.memberLevel.levelName"
              disabled
          ></v-text-field>
          <el-button style="color: #FFF;" @click="handleUpgradeVIP" type="primary">升级VIP</el-button>
          <el-link v-if="detailInfo.memberLevel.levelName !== '普通'" class="mg_l_2" type="primary" :underline="false" style="text-decoration: underline" :href="`/listMemberPurchase?memberId=${detailInfo.memberId}`">
            {{moment(detailInfo.memberExpireTime).format("YYYY-MM-DD HH:mm:SS")}}
          </el-link>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="时间"
            placeholder="时间"
            variant="underlined"
            v-model="detailInfo.lastLogin"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <el-form-item label="积分：">
          <div>
            <span class="mg_r_2">{{detailInfo.availableCredit}}</span>
            <el-link type="primary" :underline="false" style="text-decoration: underline" :href="`/listPointsRecord?userId=${detailInfo.userId}`">
              详情
            </el-link>
          </div>
        </el-form-item>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="推荐人类型"
            placeholder="推荐人类型"
            variant="underlined"
            v-model="detailInfo.referrerType"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="推荐人ID"
            placeholder="推荐人ID"
            variant="underlined"
            v-model="detailInfo.referrerId"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
            label="推荐人昵称"
            placeholder="推荐人昵称"
            variant="underlined"
            v-model="detailInfo.referrerNickname"
            disabled
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-btn color="primary" disabled>修改</v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn @click="handleToList">返回</v-btn>
      </v-col>
    </v-row>
  </div>

  <el-dialog
    v-model="isShowUpgradeDialog"
    title="确认升级为VIP？"
    width="500"
    align-center
  >
    <div class="dialog-container">
      <div class="dialog-item flex_center flex_left">用户头像：<img style="width: 34px;height: 34px;border-radius: 34px;" :src="detailInfo.avatar ? detailInfo.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'"></div>
      <div class="dialog-item">用户昵称：{{ detailInfo.nickname }}</div>
      <div class="dialog-item">用户ID：{{ detailInfo.userId }}</div>
      <div class="dialog-item">联系电话：{{ detailInfo.phone }}</div>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="isShowUpgradeDialog = false">取消</el-button>
        <el-button style="color: #FFF;" type="primary" @click="confirmUpgradeVIP">
          确认
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.dialog-container {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: 30px 70px;

}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 50px;
}
</style>
